import * as React from "react";

function SvgComponent(props?: any) {
  return (
    <svg
      width={128}
      viewBox="103.093 157.719 309.279 195.986"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className="cls-1"
        d="M279.77 201.64c-5.52 0-9 4.88-9.14 13.3-.36 9.95 3.8 23.89 11.31 24.16 3.71 0 7.69-3.26 7.69-9.68v-15.93c0-6.33-4.52-11.85-9.86-11.85z"
        fill="#3e5055"
        transform="translate(41.314 41.608)"
      />
      <path
        className="cls-1"
        d="M357.34 184.68l-160.85-65.93a19.77 19.77 0 00-14.55-.18l-106.2 40.55A19.75 19.75 0 0063.54 182L81 257.74a19.78 19.78 0 0014.67 14.78l155.82 37.19a19.73 19.73 0 0012.25-1l69.55-29.23a19.81 19.81 0 0010.6-10.65l24.17-58.3a19.76 19.76 0 00-10.72-25.85zm-169.85-13.1l8.9 8.9-8.9 8.9-8.89-8.9zm-46.33 70.52c-9.37 0-17.72-4.74-17.72-22.38v-19.18c0-4.85-4.3-5.95-4.3-8.38v-.33a2.46 2.46 0 012.2-2.31l12.55-2.1c2.75-.33 4.41.11 4.41 2l-.22 35.05c-.11 8 2 11.25 6.72 11.36 9.59.22 18.08-12 18.08-24.25 0-10.15-9.81-9.59-9.81-18 0-3.75 2.42-6.62 7.27-6.62 6.07 0 11.14 4.85 11.14 17.2 0 22.95-13.12 37.94-30.32 37.94zm59.5-1.52c0 1-.87 1.65-2.23 1.65h-17.84c-1.26 0-2.13-.68-2.13-1.65v-.39c0-2.42 3.68-3.2 3.68-7.37v-21.9c0-4.27-3.68-5.34-3.68-7.47v-.29c0-.87.78-1.36 2-2l12.11-6c2.43-1.16 4 .2 4 1.94v35.77c0 4.17 4.07 5 4.07 7.37zm27.34 0c0 1-1 1.65-2.23 1.65h-17.84c-1.36 0-2.23-.68-2.23-1.65v-.39c0-2.42 3.78-3.2 3.78-7.27v-35.68c0-4.37-3.78-5.34-3.78-7.37v-.39c0-1 .77-1.45 1.94-1.94l12.21-6c2.52-1.26 4 .1 4 1.75v49.64c0 4.07 4.17 4.85 4.17 7.27zm27.14 0c0 1-1 1.65-2.23 1.65h-17.84c-1.36 0-2.23-.68-2.23-1.65v-.39c0-2.42 3.78-3.2 3.78-7.27v-47.69c0-4.37-3.78-5.34-3.78-7.37v-.39c0-1 .78-1.45 1.94-1.94l12.21-6c2.53-1.26 4 .1 4 1.75v61.65c0 4.07 4.17 4.85 4.17 7.27zm51.05-38.13c0 1.72-3.8 2.81-3.8 7.24v23.71c0 3.8 3.53 4.71 3.53 6.88v.27c0 1-.63 1.54-1.81 1.54H293a2 2 0 01-2.08-2v-2.17A15.42 15.42 0 01279 243c-11 0-21.26-8.14-21.26-22.71 0-13.39 9.77-22.53 21.35-22.53a16.17 16.17 0 0111.86 4.61v-1.81c0-1.72 1.54-2.71 3.89-2.26l9.5 1.63a2.1 2.1 0 011.9 2.26z"
        fill="#3e5055"
        transform="translate(41.314 41.608)"
      />
    </svg>
  );
}

export default SvgComponent;
